import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { CustomEntryQuotesRequest, PositionNote, PositionsResponse } from '@zero/shared/util-models';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { AuthStateFacade } from '../../state/auth/auth-state.facade';

@Injectable({ providedIn: 'root' })
export class PositionsInfrastructure {
  private readonly _http = inject(HttpClient);
  private readonly _authStateFacade = inject(AuthStateFacade);

  private readonly _positionsEndpoint = environment.apihost + environment.positionsUrl;
  private readonly _notesEndpoint = `${environment.apihost}/api/position/notes`;

  public getPositions(): Observable<PositionsResponse> {
    return this._http.get<PositionsResponse>(this._positionsEndpoint, {
      params: {
        customerId: this._authStateFacade.customerId,
        withProtectionInfo: true,
      },
    });
  }

  public getNotes(): Observable<PositionNote[]> {
    return this._http.get<PositionNote[]>(this._notesEndpoint, {
      params: {
        customerId: this._authStateFacade.customerId,
      },
    });
  }

  public getNoteByIsin(isin: string): Observable<PositionNote> {
    return this._http.get<PositionNote>(`${this._notesEndpoint}/${isin}`, {
      params: {
        customerId: this._authStateFacade.customerId,
      },
    });
  }

  public putPositionNoteByIsin(isin: string, note: string): Observable<PositionNote> {
    return this._http.put<PositionNote>(
      `${this._notesEndpoint}/${isin}`,
      {
        isin,
        note,
      },
      {
        params: {
          customerId: this._authStateFacade.customerId,
        },
      },
    );
  }

  public deletePositionNoteByIsin(isin: string): Observable<void> {
    return this._http.delete<void>(`${this._notesEndpoint}/${isin}`, {
      params: {
        customerId: this._authStateFacade.customerId,
      },
    });
  }

  public postEntryQuotesEdit(quotes: CustomEntryQuotesRequest[]): Observable<void> {
    return this._http.post<void>(`${environment.apihost}/api/trading/entryquote/edit`, quotes, {
      params: {
        customerId: this._authStateFacade.customerId,
      },
    });
  }
}
